import PropTypes from 'prop-types'
import React from 'react'
import { ThemeContext } from 'styled-components'

import ClickableDescr from 'components/ClickableDescr'
import FrameMacSide from 'components/FrameMacSide'
import Icon from 'components/Icon'
import SectionWrapper from 'components/SectionWrapper'
import { REGION_JP } from 'constants/regions'
import { ResizeContext } from 'contexts/Resize'
import { useSwitcher } from 'hooks/saveElementIndex'
import { H1Small as H1 } from 'styles/components/typography'

import { Cover, FrameWrapper, IconWrapper, Content } from './styles'

const IMAGES =
  process.env.region === REGION_JP
    ? [
        'metabolism_150921',
        'behaviour_150921',
        'vitamins_150921',
        'intolerance_150921',
        'recommendations_150921',
      ]
    : ['metabolism', 'behaviour', 'vitamins', 'intolerance', 'recommendations']

const DResultsNutrition = props => {
  const { data, pathCdn } = props
  const { index, updateIndex } = useSwitcher()
  const { mobile } = React.useContext(ResizeContext)
  const { colors } = React.useContext(ThemeContext)

  return (
    <SectionWrapper
      isOverflowHidden={true}
      beforeElement={<Cover isTablet={true} />}
    >
      <div className="row">
        <div className="col-12 col-md-8">
          <Cover />
          <FrameWrapper className="py-md-4">
            <div className="position-relative py-4 py-md-0">
              <H1 as="h2" dangerouslySetInnerHTML={{ __html: data.title }} />
              <FrameMacSide
                src={`${pathCdn}/${IMAGES[index]}`}
                alt={IMAGES[index]}
              >
                <IconWrapper className="fish">
                  <Icon id="color_fish" />
                </IconWrapper>
                <IconWrapper className="nutrition">
                  <Icon id="color_nutrition" />
                </IconWrapper>
              </FrameMacSide>
            </div>
          </FrameWrapper>
        </div>
        <div className="col-12 py-4 col-md-4">
          <Content>
            <ul className="list--unstyled w-100">
              {data.list.map((item, key) => (
                <ClickableDescr
                  bulletColor={colors.lilacDark}
                  key={key}
                  isActive={index === key}
                  noHover={mobile || data.list.length === 1}
                  onClick={() => updateIndex(key)}
                  data={{
                    title: item.title,
                    description: item.content,
                  }}
                />
              ))}
            </ul>
          </Content>
        </div>
      </div>
    </SectionWrapper>
  )
}

DResultsNutrition.propTypes = {
  data: PropTypes.object.isRequired,
  pathCdn: PropTypes.string.isRequired,
}

export default DResultsNutrition
